import React, { useState, useEffect } from 'react';
import ProductsUpdateApprovalScreen from '../ProductsUpdateApproval/Screen/ProductsUpdateApprovalScreen';
import useNavActive from '../../components/Navbar/useNavActive';
import {
  getProductsUpdateRequest,
  getApprovedProductsUpdateRequest,
  getDeclinedProductsUpdateRequest,
  getProductsUpdateRequestApprove,
  getProductsUpdateRequestDecline,
} from '../../api/product.js';
import { getTableColumns, styles } from './const.js';
import ProductModal from './components/ProductModal.js';
import ModalToCheckProductForApproval from './components/ModalToCheckProductForApproval.js';
import Swal from 'sweetalert2';

export default function ProductsUpdateApproval() {
  useNavActive([
    'master_databases',
    'product_databases',
    'products_update_approval',
  ]);

  const [approvalData, setApprovalData] = useState([]);
  const [approvalLoading, setApprovalLoading] = useState(false);
  const [approvalTotalRows, setApprovalTotalRows] = useState(0);
  const [approvalPage, setApprovalPage] = useState(0);

  const [approvedData, setApprovedData] = useState([]);
  const [approvedLoading, setApprovedLoading] = useState(false);
  const [approvedTotalRows, setApprovedTotalRows] = useState(0);
  const [approvedPage, setApprovedPage] = useState(0);

  const [declinedData, setDeclinedData] = useState([]);
  const [declinedLoading, setDeclinedLoading] = useState(false);
  const [declinedTotalRows, setDeclinedTotalRows] = useState(0);
  const [declinedPage, setDeclinedPage] = useState(0);

  const [productModalShow, setProductModalShow] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [modalApproveBtn, setModalApproveBtn] = useState(false);
  const [modalDeclineBtn, setModalDeclineBtn] = useState(false);
  const [modalCloseBtn, setModalcloseBtn] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);

  const [productModalShowApproval, setProductModalShowApproval] =
    useState(false);

  const [activeTab, setActiveTab] = useState('approval');

  const defaultForm = {
    page_size: 50,
    page: 0,
    order_by: '',
    direction: '',
  };

  const [approvalPagePayload, setApprovalPagePayload] = useState({
    page_size: 50,
    page: approvalPage,
    order_by: '',
    direction: '',
  });

  const [approvedPagePayload, setApprovedPagePayload] = useState({
    page_size: 50,
    page: approvedPage,
    order_by: '',
    direction: '',
  });

  const [declinedPagePayload, setDeclinedPagePayload] = useState({
    page_size: 50,
    page: declinedPage,
    order_by: '',
    direction: '',
  });

  useEffect(() => {
    loadApprovalData(approvalPagePayload);
    loadApprovedData(approvedPagePayload);
    loadDeclinedData(declinedPagePayload);
  }, [activeTab]);

  // APPROVAL TAB
  useEffect(() => {
    setApprovalPagePayload((prev) => ({ ...prev, page: approvalPage }));
  }, [approvalPage]);

  useEffect(() => {
    loadApprovalData(approvalPagePayload);
  }, [approvalPagePayload]);

  // APPROVED TAB
  useEffect(() => {
    setApprovedPagePayload((prev) => ({ ...prev, page: approvedPage }));
  }, [approvedPage]);

  useEffect(() => {
    loadApprovedData(approvedPagePayload);
  }, [approvedPagePayload]);

  // DECLINED TAB
  useEffect(() => {
    setDeclinedPagePayload((prev) => ({ ...prev, page: declinedPage }));
  }, [declinedPage]);

  useEffect(() => {
    loadDeclinedData(declinedPagePayload);
  }, [declinedPagePayload]);

  const loadApprovalData = async (params) => {
    setApprovalLoading(true);
    setApprovalData([]);

    try {
      const res = await getProductsUpdateRequest(params);

      const { code, total_rows, result } = res.data.response;

      setApprovalTotalRows(total_rows);
      setApprovalData(result);
      setApprovalLoading(false);
    } catch (error) {
      console.log('DATA: ', error);
    }
  };

  const loadApprovedData = async (params) => {
    setApprovedLoading(true);
    setApprovedData([]);

    try {
      const res = await getApprovedProductsUpdateRequest(params);

      const { code, total_rows, result } = res.data.response;

      setApprovedTotalRows(total_rows);
      setApprovedData(result);
      setApprovedLoading(false);
    } catch (error) {
      console.log('DATA: ', error);
    }
  };

  const loadDeclinedData = async (params) => {
    setDeclinedLoading(true);
    setDeclinedData([]);

    try {
      const res = await getDeclinedProductsUpdateRequest(params);

      const { code, total_rows, result } = res.data.response;

      setDeclinedTotalRows(total_rows);
      setDeclinedData(result);
      setDeclinedLoading(false);
    } catch (error) {
      console.log('DATA: ', error);
    }
  };

  const approveRequest = async (product_update_no) => {
    try {
      // let { isConfirmed } = await Swal.fire({
      //   title: 'Product Approval Request',
      //   text: 'Are you  want to approve this request?',
      //   icon: 'warning',
      //   showCancelButton: true,
      // });

      // if (isConfirmed) {
      setModalLoading(true);
      const res = await getProductsUpdateRequestApprove({
        product_update_no: product_update_no,
      });
      const { code, result } = res.data.response;

      if (code === 200) {
        await Swal.fire({
          title: 'Product Approval',
          html: 'Product Approved Successfully!',
          icon: 'success',
        });
        setModalApproveBtn(false);
        setModalDeclineBtn(false);
        setModalcloseBtn(false);
        setProductModalShow(false);
        setProductModalShowApproval(false);
        setModalLoading(false);
        loadApprovalData(approvalPagePayload);
        loadApprovedData(approvedPagePayload);
        loadDeclinedData(declinedPagePayload);
      } else {
        console.log('APPROVED1: ', result);
      }
      //   setModalLoading(false);
      // } else {
      //   setModalApproveBtn(false);
      //   setProductModalShowApproval(false);
      // }
    } catch (error) {
      console.log('APPROVED2: ', error);
    }
  };

  const declineRequest = async (product_update_no) => {
    try {
      const res = await getProductsUpdateRequestDecline({
        product_update_no: product_update_no,
      });

      const { code, result } = res.data.response;

      if (code === 200) {
        setModalApproveBtn(false);
        setModalDeclineBtn(false);
        setModalcloseBtn(false);
        setModalLoading(false);
        setProductModalShow(false);
      } else {
        console.log('DECLINE1: ', result);
      }
    } catch (error) {
      console.log('DECLINE2: ', error);
    }
  };

  const handleClickApprove = (selectedProduct) => {
    //setModalApproveBtn(true);
    //setModalDeclineBtn(true);
    //setModalcloseBtn(true);
    setSelectedProduct(selectedProduct);
    setProductModalShowApproval(true);
  };

  const handdleApproveProduct = () => {
    approveRequest(selectedProduct.product_update_no);
    loadApprovalData(approvalPagePayload);
    loadApprovedData(approvedPagePayload);
    loadDeclinedData(declinedPagePayload);
  };

  const handleClickDecline = (selectedProduct) => {
    setModalDeclineBtn(true);
    setModalApproveBtn(true);
    setModalcloseBtn(true);
    setModalLoading(true);
    declineRequest(selectedProduct.product_update_no);
    setApprovalLoading(true);
    loadApprovalData(approvalPagePayload);
    loadApprovedData(approvedPagePayload);
    loadDeclinedData(declinedPagePayload);
  };

  const handleOpenProductModal = (product) => {
    // console.log('click', product);
    setSelectedProduct(product);
    // console.log('APPROVAL: ', approvalData);
    // console.log('APPROVED: ', approvedData);
    // console.log('DECLINED: ', declinedData);
    setProductModalShow(true);
  };

  const handleSelectActiveTab = (tab) => {
    setActiveTab(tab);
  };

  const columns = getTableColumns(handleOpenProductModal, activeTab);

  const handleFilterModelChange = (filterModel) => {
    if (activeTab === 'approval') {
      const newFormData = {
        ...approvalPagePayload,
        filterModel,
      };
      loadApprovalData(newFormData);
    } else if (activeTab === 'appproved') {
      const newFormData = {
        ...approvedPagePayload,
        filterModel,
      };
      loadApprovedData(newFormData);
    } else if (activeTab === 'declined') {
      const newFormData = {
        ...declinedPagePayload,
        filterModel,
      };
      loadDeclinedData(newFormData);
    }
  };

  const handleTableChange = (params) => {
    let direction;

    // flip direction manually
    if (!params.direction) {
      direction = 'desc'; // first click
    } else {
      direction = params.direction === 'asc' ? 'desc' : 'asc';
    }

    if (activeTab === 'approval') {
      setApprovalPagePayload((prev) => ({
        ...prev,
        order_by: params.order_by,
        direction,
      }));
    }

    if (activeTab === 'appproved') {
      setApprovedPagePayload((prev) => ({
        ...prev,
        order_by: params.order_by,
        direction,
      }));
    }

    if (activeTab === 'declined') {
      setDeclinedPagePayload((prev) => ({
        ...prev,
        order_by: params.order_by,
        direction,
      }));
    }
  };

  return (
    <React.Fragment>
      <ProductsUpdateApprovalScreen
        columns={columns}
        approvalData={approvalData}
        approvalLoading={approvalLoading}
        approvalTotalRows={approvalTotalRows}
        approvalPage={approvalPage}
        setApprovalPage={setApprovalPage}
        approvedData={approvedData}
        approvedLoading={approvedLoading}
        approvedTotalRows={approvedTotalRows}
        approvedPage={approvedPage}
        setApprovedPage={setApprovedPage}
        declinedData={declinedData}
        declinedLoading={declinedLoading}
        declinedTotalRows={declinedTotalRows}
        declinedPage={declinedPage}
        setDeclinedPage={setDeclinedPage}
        activeTab={activeTab}
        handleSelectActiveTab={handleSelectActiveTab}
        handleFilterModelChange={handleFilterModelChange}
        onTableChange={handleTableChange}
      />

      <ProductModal
        selectedProduct={selectedProduct}
        productModalShow={productModalShow}
        setProductModalShow={setProductModalShow}
        handleClickApprove={handleClickApprove}
        handleClickDecline={handleClickDecline}
        styles={styles}
        modalApproveBtn={modalApproveBtn}
        modalDeclineBtn={modalDeclineBtn}
        modalCloseBtn={modalCloseBtn}
        modalLoading={modalLoading}
      />

      <ModalToCheckProductForApproval
        handdleApproveProduct={handdleApproveProduct}
        productModalShowApproval={productModalShowApproval}
        setProductModalShowApproval={setProductModalShowApproval}
        data={selectedProduct}
        modalLoading={modalLoading}
        setModalApproveBtn={setModalApproveBtn}
      />
    </React.Fragment>
  );
}
